enum PropertyStateEnum {
    AustralianCapitalTerritory = 'ACT',
    NewSouthWales = 'NSW',
    NorthernTerritory = 'NT',
    Queensland = 'QLD',
    SouthAustralia = 'SA',
    Tasmania = 'TAS',
    Victoria = 'VIC',
    WesternAustralia = 'WA',
}

export default PropertyStateEnum;
